import { useLocation } from "react-router-dom";
import { motion, useReducedMotion } from "framer-motion";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import MobileNav from "@/components/layout/MobileNav";
import LiveStatusBar from "@/components/LiveStatusBar";
import SupportBot from "@/components/SupportBot";

export default function Layout({ children, hideStatus = false }) {
  const { pathname } = useLocation();
  const reduce = useReducedMotion();
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      {!hideStatus && <LiveStatusBar />}
      <main className="flex-1 pb-16 xl:pb-0">
        {reduce ? children : (
          <motion.div
            key={pathname}
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
          >
            {children}
          </motion.div>
        )}
      </main>
      <Footer />
      <MobileNav />
      <SupportBot />
    </div>
  );
}
